<div class="loading" *ngIf="loading">
  <div class="spinner-border" role="status"></div>
</div>

<div class="component-editor editor-shell container-component" *ngIf="!loading">
  <div class="editor-header">
    <div>
      <h3 class="editor-title">{{ 'CREATE_COMPONENT' | translate }}</h3>
      <p class="editor-subtitle">{{ 'COMPONENT_EDITOR_CREATE_SUBTITLE' | translate }}</p>
    </div>
  </div>

  <div class="stepper">
    <div class="stepper-progress">
      <div class="stepper-progress-bar" [style.width.%]="stepProgress"></div>
    </div>

    <div class="stepper-nav">
      <div
        *ngFor="let step of steps"
        class="stepper-chip"
        [class.is-active]="isCurrentStep(step.index)"
        [class.is-complete]="isStepComplete(step.index)"
        (click)="goToStep(step.index)"
        style="cursor: pointer;">
        <span class="stepper-index">{{ step.index }}</span>
        <div>
          <div class="stepper-label">{{ step.label | translate }}</div>
          <small>{{ step.description | translate }}</small>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="componentForm" (ngSubmit)="validateFormData()">
    <div formGroupName="component">
      <section class="step-card" *ngIf="currentStep === 1">
        <div class="step-card-header">
          <div>
            <h4 class="step-card-title">{{ 'COMPONENT_STEP_1_TITLE' | translate }}</h4>
            <p class="step-card-copy">{{ 'CREATE_COMPONENT_STEP_1_COPY' | translate }}</p>
          </div>
        </div>

        <div class="section-grid">
          <div class="section-block">
            <label class="section-label" for="componentName">{{ 'COMPONENT_NAME' | translate }}</label>
            <input
              id="componentName"
              type="text"
              class="form-control"
              formControlName="componentName"
              maxlength="40"
              [placeholder]="'COMPONENT_NAME' | translate" />
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('componentName'))">
              {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('COMPONENT_NAME' | translate) } }}
            </div>
          </div>

          <div class="section-block">
            <label class="section-label" for="componentParentId">{{ 'COMPONENT_TYPE' | translate }}</label>
            <select class="form-select" id="componentParentId" (change)="onChangeParentId($event)">
              <option [value]="0" [selected]="!selectedParentId">{{ 'SELECT_COMPONENT_TYPE' | translate }}</option>
              <option *ngFor="let parent of uniqueParentIds" [value]="parent.id" [selected]="parent.id === selectedParentId">
                {{ parent.name | translate }}
              </option>
            </select>
            <div class="error-text" *ngIf="navigationAttempted && !selectedParentId">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('COMPONENT_TYPE' | translate) } }}
            </div>
          </div>
        </div>

        <div class="section-grid single-column" *ngIf="selectedParentId > 0">
          <div class="section-block is-muted">
            <label class="section-label">{{ 'SUBSCRIPTIONS' | translate }}</label>
            <div class="switch-title-container">
              <span>{{ 'SUBSCRIPTIONS_RESTRICT_VISIBILITY' | translate }}</span>
              <label class="switch">
                <input type="checkbox" [checked]="activeSubscriptions === 1" (change)="toggle()" />
                <span class="slider"></span>
              </label>
            </div>
            <p class="helper-text" *ngIf="activeSubscriptions === 0">{{ 'SUBSCRIPTIONS_ARE_NOT_RESTRICT' | translate }}</p>

            <div class="subscription-list" *ngIf="activeSubscriptions === 1">
              <label class="subscription-chip" *ngFor="let suscripcion of clientSubscriptions">
                <input
                  type="checkbox"
                  [checked]="selectedSubscriptions.includes(suscripcion.clientSubscriptionId)"
                  (change)="toggleSuscripcion(suscripcion.clientSubscriptionId)" />
                {{ suscripcion.clientSubscriptionName }}
              </label>
            </div>
          </div>
        </div>

        <div class="section-grid single-column" *ngIf="selectedParentId === 3">
          <div class="section-block">
            <label class="section-label">{{ 'PRODUCT_SOURCE' | translate }}</label>
            <div class="option-inline-group">
              <label class="option-chip">
                <input type="radio" name="productSource" value="collections" (change)="onOptionChange('collections')" [checked]="selectedOption === 'collections'" />
                {{ 'COLLECTIONS' | translate }}
              </label>
              <label class="option-chip">
                <input type="radio" name="productSource" value="categories" (change)="onOptionChange('categories')" [checked]="selectedOption === 'categories'" />
                {{ 'CATEGORIES' | translate }}
              </label>
              <label class="option-chip">
                <input type="radio" name="productSource" value="subCategories" (change)="onOptionChange('subCategories')" [checked]="selectedOption === 'subCategories'" />
                {{ 'SUBCATEGORY' | translate }}
              </label>
              <label class="option-chip">
                <input type="radio" name="productSource" value="subSubcategories" (change)="onOptionChange('subSubcategories')" [checked]="selectedOption === 'subSubcategories'" />
                {{ 'SUB_SUBCATEGORIES' | translate }}
              </label>
            </div>

            <div class="error-text" *ngIf="navigationAttempted && !selectedOption">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('PRODUCT_SOURCE' | translate) } }}
            </div>

            <div class="section-grid" *ngIf="selectedOption">
              <div class="section-block" *ngIf="selectedOption === 'collections'">
                <label class="section-label" for="collections">{{ 'COLLECTIONS' | translate }}</label>
                <select class="form-select" id="collections" formControlName="collectionId" (change)="onCollectionChange($event)">
                  <option [value]="0">{{ 'SELECT_COLLECTION' | translate }}</option>
                  <option *ngFor="let collection of collections" [value]="collection.collectionId">
                    {{ collection.collectionName }}
                  </option>
                </select>
              </div>

              <div class="section-block" *ngIf="selectedOption === 'categories'">
                <label class="section-label" for="category">{{ 'CATEGORIES' | translate }}</label>
                <select class="form-select" id="category" formControlName="categoryId" (change)="onCategoryChange($event)">
                  <option [value]="0">{{ 'SELECT_CATEGORY' | translate }}</option>
                  <option *ngFor="let category of categories" [value]="category.categoryId">
                    {{ category.categoryName }}
                  </option>
                </select>
              </div>

              <div class="section-block" *ngIf="selectedOption === 'subCategories'">
                <label class="section-label" for="subCategory">{{ 'SUBCATEGORY' | translate }}</label>
                <select class="form-select" id="subCategory" formControlName="subCategoryId" (change)="onSubCategoryChange($event)">
                  <option [value]="0">{{ 'SELECT_CATEGORY' | translate }}</option>
                  <option *ngFor="let subCategory of subCategories" [value]="subCategory.subCategoryId">
                    {{ subCategory.subCategoryName }}
                  </option>
                </select>
              </div>

              <div class="section-block" *ngIf="selectedOption === 'subSubcategories'">
                <label class="section-label" for="subSubCategory">{{ 'SUB_SUBCATEGORIES' | translate }}</label>
                <select class="form-select" id="subSubCategory" formControlName="subSubCategoryId" (change)="onSubSubCategoryChange($event)">
                  <option [value]="0">{{ 'SELECT_SUB_SUBCATEGORY' | translate }}</option>
                  <option *ngFor="let subSubCategory of subSubCategories" [value]="subSubCategory.subSubCategoryId">
                    {{ subSubCategory.subSubCategoryName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="step-card" *ngIf="currentStep === 2">
        <div class="step-card-header">
          <div>
            <h4 class="step-card-title">{{ 'COMPONENT_STEP_2_TITLE' | translate }}</h4>
            <p class="step-card-copy">{{ 'CREATE_COMPONENT_STEP_2_COPY' | translate }}</p>
          </div>
        </div>

        <div class="section-grid single-column">
          <div class="section-block">
            <label class="section-label" id="componentTypeDesignId">{{ 'LAYOUT' | translate }}</label>
            <div
              class="layout-selection"
              [class.is-disabled]="isLayoutSelectionDisabled"
              role="radiogroup"
              aria-labelledby="componentTypeDesignId">
              <label
                *ngFor="let design of layoutOptions; trackBy: trackByLayoutOption"
                #layoutCard
                class="layout-card"
                [class.is-active]="design.typeId === componentGroup.get('componentTypeId')?.value"
                [class.is-disabled]="isLayoutSelectionDisabled"
                (mouseenter)="onLayoutCardEnter(design, layoutCard)"
                (mouseleave)="onLayoutCardLeave()"
                (focusin)="onLayoutCardEnter(design, layoutCard)"
                (focusout)="onLayoutCardLeave()">
                <input
                  class="layout-card-input"
                  type="radio"
                  name="componentTypeDesignId"
                  [value]="design.typeId"
                  [checked]="design.typeId === componentGroup.get('componentTypeId')?.value"
                  [disabled]="isLayoutSelectionDisabled"
                  (change)="onLayoutSelection(design.typeId)" />
                <span class="layout-card-media">
                  <button
                    *ngIf="usesTapPreviewMode"
                    type="button"
                    class="layout-card-preview-trigger"
                    [disabled]="isLayoutSelectionDisabled"
                    (click)="openLayoutPreviewModal(design, $event)">
                    {{ 'PREVIEW' | translate }}
                  </button>
                  <img
                    *ngIf="design.imageUrl; else createLayoutFallback"
                    [src]="sanitizeURL(design.imageUrl)"
                    loading="lazy"
                    [alt]="design.name" />
                  <ng-template #createLayoutFallback>
                    <span class="layout-card-fallback" aria-hidden="true">
                      <span class="layout-card-fallback-badge">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : ('LAYOUT' | translate) }}</span>
                      <span class="layout-card-fallback-name">{{ design.name }}</span>
                    </span>
                  </ng-template>
                </span>
                <span class="layout-card-copy">
                  <span class="layout-card-title">{{ design.name }}</span>
                </span>
              </label>
            </div>
            <div
              *ngIf="activeLayoutPreview && !usesTapPreviewMode"
              class="layout-preview-overlay"
              [ngStyle]="layoutPreviewStyle"
              aria-hidden="true">
              <div class="layout-preview-overlay__surface">
                <div class="layout-preview-overlay__title">{{ activeLayoutPreview.name }}</div>
                <div class="layout-preview-overlay__meta">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : ('LAYOUT' | translate) }}</div>
                <div class="layout-preview-overlay__media">
                  <img
                    *ngIf="activeLayoutPreview.imageUrl; else createOverlayFallback"
                    [src]="sanitizeURL(activeLayoutPreview.imageUrl)"
                    [alt]="activeLayoutPreview.name" />
                  <ng-template #createOverlayFallback>
                    <span class="layout-card-fallback" aria-hidden="true">
                      <span class="layout-card-fallback-badge">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : ('LAYOUT' | translate) }}</span>
                      <span class="layout-card-fallback-name">{{ activeLayoutPreview.name }}</span>
                    </span>
                  </ng-template>
                </div>
                <p class="layout-preview-overlay__description" *ngIf="activeLayoutPreview.description">
                  {{ activeLayoutPreview.description }}
                </p>
              </div>
            </div>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('componentTypeId'))">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('LAYOUT' | translate) } }}
            </div>
            <p class="helper-text" *ngIf="selectedParentId === 3 && !designEnabled">
              {{ 'SELECT_CATEGORY_SUBCATEGORY_OR_COLLECTION_FIRST' | translate }}
            </p>
          </div>
        </div>

        <div class="section-grid single-column" *ngIf="visibleFields.has('itemQuantity')">
          <div class="section-block">
            <label class="section-label" for="componentAmount">{{ 'ITEMS_QUANTITY' | translate }}</label>
            <select class="form-select" id="componentAmount" formControlName="itemQuantity" (change)="onItemQuantityChange($event)">
              <option [value]="0">{{ 'SELECT_ITEMS_QUANTITY' | translate }}</option>
              <option *ngFor="let quantity of [4, 8, 12, 16]" [value]="quantity">{{ quantity }}</option>
            </select>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('itemQuantity'))">
              {{ 'FIELD_SELECTION_REQUIRED' | translate:{ field: ('ITEMS_QUANTITY' | translate) } }}
            </div>
          </div>
        </div>
      </section>

      <section class="step-card" *ngIf="currentStep === 3">
        <div class="step-card-header">
          <div>
            <h4 class="step-card-title">{{ 'COMPONENT_STEP_3_TITLE' | translate }}</h4>
            <p class="step-card-copy">{{ 'CREATE_COMPONENT_STEP_3_COPY' | translate }}</p>
          </div>
        </div>

        <div class="section-grid single-column">
          <div class="section-block" [hidden]="!visibleFields.has('title')">
            <label class="section-label" for="componentTitle">{{ 'TITLE' | translate }}</label>
            <div class="quill-shell">
              <quill-editor id="componentTitle" class="title-editor" formControlName="title" [modules]="modules"></quill-editor>
            </div>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('title'))">
              {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('TITLE' | translate) } }}
            </div>
          </div>

          <div class="section-block" [hidden]="!visibleFields.has('subtitle')">
            <label class="section-label" for="componentSubtitle">{{ 'SUBTITLE' | translate }}</label>
            <div class="quill-shell">
              <quill-editor id="componentSubtitle" class="subtitle-editor" formControlName="subtitle" [modules]="modules"></quill-editor>
            </div>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('subtitle'))">
              {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('SUBTITLE' | translate) } }}
            </div>
          </div>

          <div class="section-block" [hidden]="!visibleFields.has('description')">
            <label class="section-label" for="description-edit">{{ 'DESCRIPTION' | translate }}</label>
            <div class="quill-shell">
              <quill-editor id="description-edit" class="description-editor" formControlName="description" [modules]="modules" (onEditorChanged)="descriptionChanged($event)"></quill-editor>
            </div>
            <div class="helper-text">{{ 'REMAINING_CHARACTERS' | translate }}: {{ remainingCharacters }} / {{ maxLength }}</div>
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('description'))">
              {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('DESCRIPTION' | translate) } }}
            </div>
          </div>

          <div class="section-block" [hidden]="!visibleFields.has('shopContactMail')">
            <label class="section-label" for="shopContactMail">{{ 'SHOP_CONTACT_MAIL' | translate }}</label>
            <input
              id="shopContactMail"
              type="email"
              class="form-control"
              formControlName="shopContactMail"
              maxlength="50"
              [placeholder]="'SHOP_CONTACT_MAIL' | translate" />
            <div class="error-text" *ngIf="shouldShowControlError(componentGroup.get('shopContactMail'))">
              {{ 'VALID_EMAIL_MESSAGE' | translate }}
            </div>
          </div>

          <div class="section-block translation-note">
            <label class="section-label">{{ 'ENGLISH_TRANSLATION_TITLE' | translate }}</label>
            <p class="helper-text">{{ 'ENGLISH_TRANSLATION_CREATE_HELPER' | translate }}</p>
          </div>
        </div>
      </section>
    </div>

    <section class="step-card" *ngIf="currentStep === 4">
      <div class="step-card-header">
        <div>
          <h4 class="step-card-title">{{ 'COMPONENT_STEP_4_TITLE' | translate }}</h4>
          <p class="step-card-copy">{{ 'CREATE_COMPONENT_STEP_4_COPY' | translate }}</p>
        </div>
      </div>

      <div class="items-shell" *ngIf="usesInfoTabs; else noItemsTemplate">
        <div class="tabs-row">
          <button
            *ngFor="let field of infoFields.controls; let i = index; trackBy: trackByIndex"
            type="button"
            class="item-tab"
            [class.is-active]="selectedIndex === i"
            [class.is-valid]="getTabState(i) === 'valid'"
            [class.is-error]="getTabState(i) === 'error'"
            (click)="selectItem(i)">
            <span
              class="tab-dot"
              [class.is-valid]="getTabState(i) === 'valid'"
              [class.is-incomplete]="getTabState(i) === 'incomplete'"
              [class.is-error]="getTabState(i) === 'error'"></span>
            {{ 'ITEM_WITH_INDEX' | translate:{ index: i + 1 } }}
          </button>

          <button type="button" class="add-tab-btn" (click)="addNewField()">+</button>
        </div>

        <div class="item-panels" *ngIf="infoFields.length > 0; else emptyItemTemplate">
          <div
            *ngFor="let field of infoFields.controls; let i = index; trackBy: trackByIndex"
            class="item-panel"
            [id]="'create-item-panel-' + i"
            [formGroup]="$any(field)"
            [hidden]="selectedIndex !== i">
            <div class="item-panel-header">
              <h5 class="item-panel-title">{{ 'ITEM_WITH_INDEX' | translate:{ index: i + 1 } }}</h5>
              <button type="button" class="delete-button" (click)="removeField(i)">x</button>
            </div>

            <div class="item-layout">
              <div class="item-form-column">
                <div class="section-block" [hidden]="!visibleFields.has('infoVideoUrl')">
                  <label class="section-label" [for]="'videoTypeSelect-' + i">{{ 'VIDEO_SOURCE' | translate }}</label>
                  <select class="form-select" [id]="'videoTypeSelect-' + i" formControlName="videoUrlType" (change)="onVideoSourceChange(i, $event)">
                    <option [value]="1">{{ 'UPLOAD_FILE' | translate }}</option>
                    <option [value]="2">{{ 'INSERT_VIDEO_URL' | translate }}</option>
                  </select>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('infoVideoUrl') || field.get('videoUrlType')?.value != 2">
                  <label class="section-label">{{ 'MANUAL_VIDEO_URL' | translate }}</label>
                  <input
                    type="text"
                    class="form-control"
                    [value]="field.get('videoManualURL')?.value"
                    (input)="handleVideoManualURLChange(i, $event)"
                    placeholder="https://example.com/video.mp4" />
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('infoTitle')">
                  <label class="section-label" [for]="'infoTitle-' + i">{{ 'ITEM_TITLE' | translate }}</label>
                  <div class="quill-shell">
                    <quill-editor class="info-title-editor" [id]="'infoTitle-' + i" formControlName="infoTitle" [modules]="modules"></quill-editor>
                  </div>
                  <div class="error-text" *ngIf="shouldShowControlError(field.get('infoTitle'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ITEM_TITLE' | translate) } }}</div>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('infoDescription')">
                  <label class="section-label" [for]="'infoDescription-' + i">{{ 'ITEM_DESCRIPTION' | translate }}</label>
                  <div class="quill-shell">
                    <quill-editor class="info-description-editor" [id]="'infoDescription-' + i" formControlName="infoDescription" [modules]="modules" (onEditorChanged)="infoDescriptionChanged($event, i)"></quill-editor>
                  </div>
                  <div class="helper-text">{{ 'REMAINING_CHARACTERS' | translate }}: {{ getInfoRemainingCharacters(i) }} / {{ infoMaxLength }}</div>
                  <div class="error-text" *ngIf="shouldShowControlError(field.get('infoDescription'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ITEM_DESCRIPTION' | translate) } }}</div>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('urlName')">
                  <label class="section-label">{{ 'LINK_TEXT' | translate }}</label>
                  <input type="text" class="form-control" formControlName="urlName" maxlength="50" />
                  <div class="error-text" *ngIf="shouldShowControlError(field.get('urlName'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('LINK_TEXT' | translate) } }}</div>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('redirectUrl')">
                  <label class="section-label">{{ 'ENGLISH_REDIRECT_URL' | translate }}</label>
                  <input type="text" class="form-control" formControlName="redirectUrl" placeholder="https://example.com" />
                  <div class="error-text" *ngIf="shouldShowControlError(field.get('redirectUrl'))">{{ 'INVALID_URL_FORMAT' | translate }}</div>
                </div>
              </div>

              <div class="item-media-column">
                <div class="section-block" [hidden]="!visibleFields.has('infoImageUrl')">
                  <label class="section-label">{{ 'ITEM_IMAGE' | translate }}</label>
                  <div class="media-actions">
                    <button type="button" class="media-btn" (click)="triggerFileInput(i, 'image')">{{ 'UPLOAD_IMAGE' | translate }}</button>
                    <input [id]="'btn-upload-image-' + i" type="file" class="d-none" accept="image/*" (change)="handleFileSelection(i, $event, 'image')" />
                  </div>

                  <div class="media-preview" *ngIf="field.get('imageURL')?.value">
                    <img [src]="sanitizeURL(field.get('imageURL')?.value)" [alt]="'UPLOADED_IMAGE' | translate" />
                    <button type="button" class="delete-button" (click)="removeMedia(i, 'imageURL')">{{ 'REMOVE' | translate }}</button>
                  </div>

                  <div class="error-text" *ngIf="shouldShowControlError(field.get('imageURL'))">{{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ITEM_IMAGE' | translate) } }}</div>
                </div>

                <div class="section-block" [hidden]="!visibleFields.has('infoVideoUrl')">
                  <label class="section-label">{{ 'ITEM_VIDEO' | translate }}</label>
                  <div class="media-actions" [hidden]="field.get('videoUrlType')?.value != 1">
                    <button type="button" class="media-btn" (click)="triggerFileInput(i, 'video')">{{ 'UPLOAD_VIDEO' | translate }}</button>
                    <input [id]="'btn-upload-video-' + i" type="file" class="d-none" accept="video/*" (change)="handleFileSelection(i, $event, 'video')" />
                  </div>

                  <div class="media-preview" *ngIf="field.get('videoURL')?.value">
                    <video #videoPlayer controls (loadedmetadata)="captureThumbnail(videoPlayer)">
                      <source [src]="sanitizeURL(field.get('videoURL')?.value)" type="video/mp4" />
                    </video>
                    <button type="button" class="delete-button" (click)="removeMedia(i, 'videoURL')">{{ 'REMOVE' | translate }}</button>
                  </div>

                  <div class="media-preview" *ngIf="field.get('videoUrlType')?.value == 2 && field.get('videoManualURL')?.value">
                    <iframe *ngIf="isYouTubeVideo(field.get('videoManualURL')?.value)" [src]="sanitizeVideoURL(field.get('videoManualURL')?.value)" frameborder="0" allowfullscreen></iframe>
                    <video *ngIf="!isYouTubeVideo(field.get('videoManualURL')?.value)" controls>
                      <source [src]="sanitizeURL(field.get('videoManualURL')?.value)" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyItemTemplate>
        <div class="section-block is-muted">
          <p class="helper-text">{{ 'ADD_ITEM_FOR_LAYOUT' | translate }}</p>
        </div>
      </ng-template>

      <ng-template #noItemsTemplate>
        <div class="section-block is-muted">
          <p class="helper-text">{{ 'LAYOUT_WITHOUT_DYNAMIC_ITEMS' | translate }}</p>
        </div>
      </ng-template>
    </section>

    <div class="step-actions" *ngIf="currentStep < 4">
      <button type="button" class="btn-step btn-secondary" (click)="prevStep()" [disabled]="currentStep === 1">
        {{ 'PREVIOUS' | translate }}
      </button>
      <button type="button" class="btn-step btn-primary" (click)="nextStep()">
        {{ 'NEXT' | translate }}
      </button>
    </div>

    <div class="form-buttons" *ngIf="currentStep === 4">
      <button type="button" class="btn-step btn-secondary" (click)="prevStep()">{{ 'PREVIOUS' | translate }}</button>
      <button type="submit" class="submit-btn">
        {{ 'CREATE' | translate }}
      </button>
    </div>
  </form>
</div>

<div class="layout-preview-modal" *ngIf="previewModalDesign">
  <button type="button" class="layout-preview-modal__backdrop" [attr.aria-label]="'CLOSE_PREVIEW' | translate" (click)="closeLayoutPreviewModal()"></button>
  <div class="layout-preview-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="layoutPreviewModalTitle">
    <div class="layout-preview-modal__header">
      <h4 id="layoutPreviewModalTitle">{{ previewModalDesign.name }}</h4>
      <button type="button" class="layout-preview-modal__close" (click)="closeLayoutPreviewModal()">×</button>
    </div>
    <div class="layout-preview-modal__body">
      <div class="layout-preview-modal__media">
        <img
          *ngIf="previewModalDesign.imageUrl; else createModalFallback"
          [src]="sanitizeURL(previewModalDesign.imageUrl)"
          [alt]="previewModalDesign.name" />
        <ng-template #createModalFallback>
          <span class="layout-card-fallback" aria-hidden="true">
            <span class="layout-card-fallback-badge">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : ('LAYOUT' | translate) }}</span>
            <span class="layout-card-fallback-name">{{ previewModalDesign.name }}</span>
          </span>
        </ng-template>
      </div>
      <div class="layout-preview-modal__copy">
        <div class="layout-preview-modal__meta">{{ selectedParentId ? (parentIdNames[selectedParentId] | translate) : ('LAYOUT' | translate) }}</div>
        <p class="layout-preview-modal__description" *ngIf="previewModalDesign.description">
          {{ previewModalDesign.description }}
        </p>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="successcomponentModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'SUCCESS' | translate }}</h3>
        <p class="text-center">{{ 'COMPONENT_CREATED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorcomponentModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ 'ERROR_SAVING_CHANGES' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorCreateFileSizeModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ 'ERROR_FILE_SIZE' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorMaxMinItemModal" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ errorMessage }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal component-confirm-modal fade" id="errorRedirectUrl" tabindex="-1">
  <div class="modal-dialog component-modal-dialog" role="document">
    <div class="modal-content component-modal-content">
      <div class="modal-body component-modal-body">
        <h3 class="text-center">{{ 'ERROR' | translate }}</h3>
        <p class="text-center">{{ 'INVALID_URL' | translate }}{{ itemListId }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
